module.exports = __webpack_public_path__ + "img/icon-warning.408f23db.svg";